import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';

export default function RankingSection() {
  const { t } = useTranslation();
  const ranked = [...articles].sort((a, b) => b.rating - a.rating).slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 bg-secondary-100 text-secondary-800 text-xs font-semibold rounded-full uppercase tracking-wider mb-4">
            Top Rated
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            {t('section.ranking')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {ranked.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="flex items-center gap-4 p-4 bg-background-50 rounded-lg hover:bg-background-200/50 transition-colors cursor-pointer group"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                {index < 3 ? (
                  <span className="w-10 h-10 flex items-center justify-center bg-accent-500 text-background-50 font-heading text-lg font-bold rounded-full">
                    {index + 1}
                  </span>
                ) : (
                  <span className="w-10 h-10 flex items-center justify-center bg-foreground-200 text-foreground-600 font-heading text-lg font-bold rounded-full">
                    {index + 1}
                  </span>
                )}
              </div>

              <div className="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-1 text-xs text-foreground-500">
                  <span>{article.director}</span>
                  <span>{article.year}</span>
                </div>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1">
                <i className="ri-star-fill text-accent-500 text-sm"></i>
                <span className="font-heading text-lg font-bold text-foreground-900">{article.rating}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}